/**
 * Display-only fields the page adds to the copy of each cue it draws (pages.vue
 * positionedCues, print-pages.vue): connector line ends, box offset, body height.
 * They are recomputed on every render and nothing reads them back from the cue doc.
 *
 * The cue boxes hold that drawn copy, so every save used to write them into the
 * doc too, and the show was stamped edited for numbers no one changed ("opening =
 * edited", Josh, 20 Oct 2026). Old cues already carry them; they are left there
 * (harmless, and deleting them would itself be a write to every show).
 */
export const DRAWING_FIELDS = ['lineX1', 'lineX2', 'lineY1', 'lineY2', 'offsetX', 'offsetY', 'currentHeight'];

/** A shallow copy of the cue without the drawing fields; the caller's cue is not changed. */
export function withoutDrawingFields(cue) {
    const out = { ...cue };
    for (const key of DRAWING_FIELDS) {
        delete out[key];
    }
    return out;
}


// WEBPACK FOOTER //
// ./src/lib/cue-drawing-fields.js